require('./snooze-notif-modal-styles.less');

angular.module('bbl.modals')
  .controller('SnoozeNotifModalCtrl', ['$scope', 'Toast', 'Auth', function SnoozeNotifModalCtrl($scope, Toast, Auth) {
    var snooze = Toast.snooze();
    $scope.fm = function(date) {
      return moment(+date).format('MMMM Do, h:mm a');
    };

    $scope.valMap = {
      0: 'do not mute',
      1: '30 minutes',
      2: '1 hour',
      3: '24 hours',
      4: 'current session',
      5: 'always muted',
    };

    $scope.max = Object.keys($scope.valMap).sort().reverse()[0];

    var setFor = function(d) { return Date.now() + d*60*1000; };
    var getSnoozeEndDate = function() {
      return ({
        0: function() { return -1; },
        1: setFor.bind(0, 30),
        2: setFor.bind(0, 60),
        3: setFor.bind(0, 24*60),
        4: setFor.bind(0, 30*24*60),
        5: function() { return 'Infinity'; },
      }[$scope.d.snooze])();
    };

    var option = snooze.option !== undefined ? snooze.option : 0;
    var snoozeEnd = snooze.end;

    if (snoozeEnd === 'Infinity') {
      option = $scope.max;
    }

    if (snoozeEnd !== 'Infinity' && +snoozeEnd < Date.now()) {
      option = 0;
    }

    $scope.d = {
      snooze: option,
      snoozed: option,
      end: snoozeEnd,
    };

    $scope.save = function saveNotificationsSettings() {
      Toast.snooze(getSnoozeEndDate(), $scope.d.snooze);

      Auth.getProfile().then(function(r) {
        Auth.setProfile(angular.extend({}, r.data.profile, {
          toast_notifications: $scope.d.snooze !== $scope.max,
        }));
      }).catch(angular.noop);
    };
  }]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/modals/snooze-notif-modal-controller.js
 ** module id = 150
 ** module chunks = 0
 **/